//#region src/resources/batch-answer/ShouldMockBatchAnswer.ts
var e = (e) => e !== !1;
//#endregion
export { e as shouldMockBatchAnswer };

//# sourceMappingURL=ShouldMockBatchAnswer.js.map